import {
  generateDefaultGridSetting,
  generateDefaultProductMenu,
  generateDefaultTopLeaderBoardBanner,
} from '../SalesChannelEditorAllProductPage/common';
import { gridSetting, menu } from './constant';

export default {
  pc: {
    topLeaderBoardBanner: generateDefaultTopLeaderBoardBanner(),
    [menu]: generateDefaultProductMenu(),
    [gridSetting]: generateDefaultGridSetting(),
  },
  tablet: {
    topLeaderBoardBanner: generateDefaultTopLeaderBoardBanner(),
    [menu]: generateDefaultProductMenu(),
    [gridSetting]: generateDefaultGridSetting(),
  },
  mobile: {
    topLeaderBoardBanner: generateDefaultTopLeaderBoardBanner(),
    [menu]: generateDefaultProductMenu(),
    [gridSetting]: generateDefaultGridSetting(),
  },
};
